import { Message } from 'element-ui';
import Vue from "vue"

export default {
    methods: {
        logout() {
            let that = this;
            this.$request.logout().then(res => {
                console.log(res.data);
                Message({
                    message: "Successfully Logout!",
                    type: "success"
                })
                this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
                Vue.prototype.$serverAccessToken = ""
                that.$router.push({ path: "/home" });
            }, 'success').catch((err) => {
                console.log(err)
                // Message({
                //     message: "User was already logged out",
                //     type: "success"
                // })
                this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
                Vue.prototype.$serverAccessToken = ""
                that.$router.push({ path: "/home" });
            });
        },
    }
}